import { DefaultLoader } from "@/components/loaders/DefaultLoader/DefaultLoader";
import { UserPanel } from "@/components/modals/UserPanel/UserPanel";
import { ChangesBox } from "@/components/Notifications/Changes/ChangesBox";
import { MiniNotificationsManager } from "@/components/Notifications/MiniNotification/MiniNotificationsManager";
import { Login } from "@/layouts/Login";
import { authStore } from "@/stores/AuthStore";
import { store } from "@/stores/redux/store";
import { userStore } from "@/stores/UserStore";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { GeneralBlock } from "../GeneralBlock/GeneralBlock";
import { MenuLeft } from "../MenuLeft";

export const OverlayPrimary = observer(() => {
  const [viewDefaultLoad, setViewDefaultLoad] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("api_token");
    if (token) {
      authStore.checkAuth();
    }
  }, []);

  useEffect(() => {
    // Показываем лоадер если что-то загружается
    if (authStore.isLoading || userStore.isLoading) {
      setViewDefaultLoad(true);
    }
  }, [authStore.isLoading, userStore.isLoading]);

  if (viewDefaultLoad || userStore.isLoading) {
    return (
      <DefaultLoader
        elementIsReady={!authStore.isLoading && !userStore.isLoading}
        callBackEndAnimation={() => setViewDefaultLoad(false)}
      />
    );
  }

  return (
    <>
      {!userStore.isLoading && (
        <>
          {!authStore.neededLogin ? (
            <Provider store={store}>
              <MenuLeft />
              <GeneralBlock />
              <UserPanel />
              <ChangesBox />
            </Provider>
          ) : (
            <Login />
          )}
          <MiniNotificationsManager />
        </>
      )}
    </>
  );
});
